import React from 'react';
import PropTypes from 'prop-types';

const ActivityCalendar = ({ 
    calendarDays, 
    selectedDate, 
    onDateSelect,
    loading
}) => {
    // Names of days for the header
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    
    if (loading) {
        return <div className="loading-spinner">Loading calendar data...</div>;
    }
    
    // Check if day has any activity
    const hasActivity = (day) => {
        return day.activities && Object.keys(day.activities).length > 0;
    };

    return (
        <>
            <div className="calendar-header">
                {dayNames.map(day => (
                    <div key={day} className="day-header">{day}</div>
                ))}
            </div>
            <div className="calendar-grid">
                {calendarDays.map((day, index) => (
                    <div
                        key={index}
                        className={`calendar-day
                            ${day.isCurrentMonth ? '' : 'other-month'}
                            ${day.isToday ? 'today' : ''}
                            ${selectedDate && day.date === selectedDate ? 'selected' : ''}
                            ${day.isCurrentMonth && hasActivity(day) ? 'has-activity' : ''}`}
                        onClick={() => day.isCurrentMonth && onDateSelect(day.date)}
                    >
                        <div className="day-number">{day.dayOfMonth}</div>
                        {day.activities && day.isCurrentMonth && (
                            <div className="activity-summary">
                                {Object.entries(day.activities).map(([type, count]) => (
                                    <div key={type} className="activity-item">
                                        <span>{type}</span>
                                        <span className="activity-count">{count}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </>
    );
};

ActivityCalendar.propTypes = {
    calendarDays: PropTypes.arrayOf(PropTypes.shape({
        date: PropTypes.string.isRequired,
        dayOfMonth: PropTypes.number.isRequired,
        isCurrentMonth: PropTypes.bool.isRequired,
        isToday: PropTypes.bool.isRequired,
        activities: PropTypes.object
    })).isRequired,
    selectedDate: PropTypes.string,
    onDateSelect: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

ActivityCalendar.defaultProps = {
    loading: false
};

export default ActivityCalendar;
